import React from 'react';
import ColorSelectItem from './ColorSelectItem.js';
import UserImage from "./UserImage";
import SymbolSelectItem from "./SymbolSelectItem";
import UserImageSelectItem from "./UserImageSelectItem";
import ImageCropper from "./ImageCropper";


class DesignerUserUpload extends React.Component {

    client = null;
    imageBaseUrl = 'https://dev1.hunde-shop.de//out/pictures/productdesigner/userupload/';

    constructor(props) {
        super(props);

        this.state = {
            fileName: '',
            fileSize: '',
            fileType: '',
            errorText: '',
            prozent: 33,
            uploadedImages: [],
            showProgressBar: false,
            enableUploadButton: false,
            showAbortButton: false,
            currentCropperImage: false,

            // showProgressBar: true,
            // enableUploadButton: true,
            // showAbortButton: true,
        }

        this.handleSelect = this.handleSelect.bind(this);
        this.fileChange = this.fileChange.bind(this);
        this.uploadAbort = this.uploadAbort.bind(this);
        this.uploadFile = this.uploadFile.bind(this);
        this.handleCropperClose = this.handleCropperClose.bind(this);
        this.handleCropperDone = this.handleCropperDone.bind(this);
        this.handleImageEdit = this.handleImageEdit.bind(this);
        this.handleImageRemove = this.handleImageRemove.bind(this);
    }

    handleSelect(color) {
        this.props.onColorSelect(color);
    }

    fileChange()
    {
        //FileList Objekt aus dem Input Element mit der ID "DesignerUserFileUpload"
        var fileList = this.imageUploadFile.files;

        //File Objekt (erstes Element der FileList)
        var file = fileList[0];

        //File Objekt nicht vorhanden = keine Datei ausgewählt oder vom Browser nicht unterstützt
        if(!file)
            return;

        let errorText = '';
        if (file.size > 5000000)
            errorText = 'Dein Bild zu groß (Maximal 5Mb)'

        if (file.type != 'image/jpeg')
            errorText = 'Deine Datei wird leider nicht unterstüzt (Nur .jpg)';

        this.setState({
            fileName: file.name,
            fileSize: file.size + 'B',
            fileType: file.type,
            prozent: 0,
            errorText: errorText,
        }, function(){

            if (errorText == '')
                this.uploadFile();
        });

    }

    uploadAbort() {
        if(this.client instanceof XMLHttpRequest)
            this.client.abort();

        this.setState({
            prozent: 0,
            showProgressBar: false,
            showAbortButton: false,
        });
    }

    handleCropperClose()
    {
        this.setState({
            currentCropperImage: false
        });
    }

    handleCropperDone(userImage)
    {
        let uploadedImages = this.state.uploadedImages;
        uploadedImages.push(userImage);
        this.setState({
            uploadedImages: uploadedImages,
        });

        this.props.onUserImageSelect(userImage);
    }

    uploadFile()
    {
        var file = this.imageUploadFile.files[0];
        var formData = new FormData();
        this.client = new XMLHttpRequest();


        if(!file)
            return;

        //Fügt dem formData Objekt unser File Objekt hinzu
        formData.append("datei", file);

        this.client.onerror = function(e) {
            this.setState({
                errorText: 'Fehler beim hochladen!',
                prozent: 0,
                showProgressBar: false
            });
        };
        this.client.onerror = this.client.onerror.bind(this);


        this.client.onload = function(e) {

            let errorText = '';
            let uploadedImages = this.state.uploadedImages;
            let currentCropperImage = false;

            if (this.client.responseText.indexOf('ERROR') != -1)
            {
                errorText = 'Fehler beim hochladen!';
            }
            else
            {
                currentCropperImage = new UserImage(this.client.responseText);
            }

            this.imageUploadFile.value = null;

            this.setState({
                errorText: errorText,
                prozent: 100,
                uploadedImages: uploadedImages,
                showProgressBar: false,
                showAbortButton: false,
                currentCropperImage: currentCropperImage
            });
        };
        this.client.onload = this.client.onload.bind(this);


        this.client.upload.onprogress = function(e) {
            var p = Math.round(100 / e.total * e.loaded);
            this.setState({
                prozent: p,
                showProgressBar: true
            });
        };
        this.client.upload.onprogress = this.client.upload.onprogress.bind(this);


        this.client.onabort = function(e) {
            this.setState({
                prozent: 0,
                showProgressBar: false
            });
        };
        this.client.onabort = this.client.onabort.bind(this);

        this.setState({
            showProgressBar: true,
            showAbortButton: true,
        });

        this.client.open("POST", this.props.userUploadInterface + "&fnc=uploadUserImage");
        this.client.send(formData);
    }


    handleSelect(image) {
        this.props.onUserImageSelect(image);
    }

    handleImageEdit(image)
    {
        const currentCropperImage = new UserImage(image.getImageOriginalName());

        this.setState({
            currentCropperImage: currentCropperImage,
        });
    }

    handleImageRemove(image)
    {
        const newImages = this.state.uploadedImages.filter(function( obj ) {
            return obj.getImageName() !== image.getImageName();
        });

        this.setState({
            uploadedImages: newImages,
        });
    }

    render() {

        const userImages = this.state.uploadedImages.map( image => {
            return <UserImageSelectItem
                key={image.id}
                image={image}
                onUserImageSelect={this.handleSelect}
                onUserImageEdit={this.handleImageEdit}
                onUserImageRemove={this.handleImageRemove}
            />
        });




        return (
            [
                <ImageCropper key="imageCropper"
                    image={this.state.currentCropperImage !== false ? this.state.currentCropperImage.getImageUrl() : false}
                    imageName={this.state.currentCropperImage !== false ? this.state.currentCropperImage.getImageName() : false}
                    onCropperClose={this.handleCropperClose}
                    activePerspective={this.props.activePerspective}
                    activeBackground={this.props.activeBackground}
                    onCropperDone ={this.handleCropperDone}
                    userUploadInterface={this.props.userUploadInterface}
                />,
                <div key="userImageUpload" className="designer_color_select designer_controll row">
                    <div className="designer_controll_title col-sm-2 col-md-1">
                        Eigenes Bild hochladen:
                    </div>
                    <div className="designer_controll_actions col-sm-10 col-md-11">
                        <div className="col-xs-12 col-sm-6 col-md-4">
                            <form action="" method="post" encType="multipart/form-data">
                                <label className="btn btn-default" htmlFor="DesignerUserFileUpload">Bild auswählen</label>
                                <input style={{opacity: 0, display: 'none'}} name="file" type="file" id="DesignerUserFileUpload" accept="image/jpeg" ref={ (imageUploadFile) => this.imageUploadFile = imageUploadFile} onChange={this.fileChange} />
                                <div className="userupload_buttons">
                                    <input className="btn btn-success" style={{ visibility: this.state.showAbortButton ? 'visible' : 'hidden'}} name="abort" value="Abbrechen" type="button" onClick={this.uploadAbort}/>
                                </div>
                            </form>
                            <div>
                                <div className="userupload_progress" style={{ visibility: this.state.showProgressBar ? 'visible' : 'hidden'}}>
                                    <div className="userupload_progress_inner" style={{width: this.state.prozent + '%'}}></div>
                                </div>
                                <span className="userupload_error">{this.state.errorText}</span>
                            </div>
                        </div>
                        <div className="col-xs-12 col-sm-6 col-md-8">
                            { userImages }
                        </div>
                    </div>
                </div>
            ]

        );
    }
}
export default DesignerUserUpload;



// WEBPACK FOOTER //
// ./src/DesignerUserUpload.js